export default __webpack_public_path__ + "static/media/ic_chevron_right_black_24px.44c671c3.svg";